export function isMultiTouchEvent(event: (MouseEvent | TouchEvent)) {
    if ('touches' in event) {
        return event.touches.length >= 2
    }
    return false
}

export function getClientEventCoords(event: (MouseEvent | TouchEvent)) {
    let clientX
    let clientY
    let isTouch = false

    if ('touches' in event) {
        if (event.touches.length) {
            clientX = event.touches[0].clientX
            clientY = event.touches[0].clientY
            isTouch = true
        }
    } else {
        clientX = event.clientX
        clientY = event.clientY
    }

    return { clientX, clientY, isTouch }
}

export function getMultiTouchAngle(event: TouchEvent) {
    if (!isMultiTouchEvent(event)) {
        return 0
    }

    const { clientX: x1, clientY: y1 } = event.touches[0]
    const { clientX: x2, clientY: y2 } = event.touches[1]

    return Math.atan2((y2 - y1), (x2 - x1))
}
